var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"myAvatar"},[_c('van-uploader',{attrs:{"after-read":_vm.afterRead}},[_c('img',{ref:"usersImg",staticClass:"avartr",attrs:{"src":_vm.avatar}})]),_c('div',{staticClass:"avartrName"},[_vm._v(_vm._s(_vm.userName))])],1),_c('div',{staticClass:"out",on:{"click":_vm.goOut}},[_vm._v("退出登录")])])
}
var staticRenderFns = []

export { render, staticRenderFns }